import styled from "styled-components";

export const ContainerSinRed = styled.div`
  width: 95%;
  height: 500px;
  background-color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  position: relative;
  h1 {
    color: var(--color-latex10);
    font-weight: 700;
    margin: 0;
    padding: 0;
    text-align: center;
    font-size: 24px;
  }
  span {
    font-size: 18px;
    line-height: 150%;
    color: var(--color-grey45);
    text-align: center;
    font-weight: 500;
  }
  border-radius: 20px;
  button {
    width: 304px;
    height: 45px;
    flex-shrink: 0;
    background-color: var(--color-primary);
    color: var(--color-white);
    font-size: 18px;
    border-radius: 8px;
    font-weight: 500;
  }
  .logo {
    position: absolute;
    top: -12%;
  }
`;
